import React, { useEffect, useState } from "react";
import logodark from "../motos_lp/assets/images/Easy-MembrLogo.png";
import { NavbarBrand } from "reactstrap";
import { Link } from "react-router-dom";
import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import { getCustomisableCancellation } from "../services/apiServices.js";
import { defaultPolicyContent } from "../utils/DefaultPolicyData"

function Cancellation() {
    const [imageLoaded, setimageLoaded] = useState(true);
    const [logourl, setlogourl] = useState(
        localStorage.getItem("loggedUserInfo")
            ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl || logodark
            : logodark
    );

    const [policyData, setPolicyData] = useState({
        title: 'Cancellation Policy',
        details: defaultPolicyContent
    });


    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const gymId = localStorage.getItem("loggedUserInfo") && JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;

    useEffect(() => {
        async function fetchCancellationPolicy() {
            try {
                setLoading(true);
                const response = await getCustomisableCancellation(gymId);

                if (!response || response === "false") {
                    setLoading(false);
                    return;
                }

                const result = await response.json();
                console.log("Fetched policy data:", result);

                if (result?.title || result?.cancellationPolicy) {
                    setPolicyData({
                        title: result.title || 'Cancellation Policy',
                        details: result.cancellationpolicy || policyData.details
                    });
                }
            } catch (error) {
                console.error("Error fetching cancellation policy:", error);
                setError(true);
            } finally {
                setLoading(false);
            }
        }

        if (gymId) {
            fetchCancellationPolicy();
        } else {
            setLoading(false);
        }
    }, [gymId]);



    const truncateContent = (content, maxLength) => {
        if (content && (content.length > maxLength)) {
            return content.substring(0, maxLength) + '...';
        } else {
            return content;
        }
    };
    const stripHtmlTags = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };
    return (
        <>
            <div className="mb-10">
                <nav
                    id="navbar"
                    className="navbar navbar-expand-lg fixed-top sticky align-items-center justify-content-center"
                >
                    <NavbarBrand to="/">
                        {imageLoaded ? (
                            <div className="d-flex align-items-center position-relative">
                                <img
                                    src={logourl}
                                    alt="Logo"
                                    className="newLogo"
                                    onLoad={() => setimageLoaded(true)}
                                    onError={() => setimageLoaded(false)}
                                />
                            </div>
                        ) : (
                            <div className="d-flex align-items-center position-relative">
                                <img src={logodark} alt="Default Logo" className="newLogo" />
                                <div className="text-dark fs-6 ByZencruzText">By Zencruz</div>
                            </div>
                        )}
                    </NavbarBrand>
                    <div className="back-to-home">
                        <Link to={-1}>
                            <MDBBtn>
                                <MDBIcon fas icon="arrow-left" />
                            </MDBBtn>
                        </Link>
                    </div>
                </nav>
            </div>


            <h3 className="py-4 container font">{policyData.title}:</h3>

            <div className="container font">
                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2">Loading policy...</p>
                    </div>
                ) : error ? (
                    <div className="alert alert-warning" role="alert">
                        <MDBIcon fas icon="exclamation-triangle" className="me-2" />
                        Unable to load cancellation policy. Please try again later.
                    </div>
                ) : (
                    <div
                        style={{ fontSize: '16px' }}
                        title={stripHtmlTags(policyData.details)}
                        dangerouslySetInnerHTML={{
                            __html: truncateContent(policyData.details, 3000)
                        }}
                    />
                )}
            </div>
        </>
    );
}

export default Cancellation;
